// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"118":"9570cf35","276":"7e8e13af","432":"ca234a22","586":"247fa363","669":"700a2d80","811":"53148a75","826":"a4c10a30","856":"c23a3a5a","890":"3e236201","918":"22e2f359","954":"edd4dda4"}[chunkId] + ".chunk.css";
};